import React from 'react'
import { format } from 'date-fns'

import { LgySubsection } from 'app/components/util/lgy-section/LgySection'
import { formatPhone } from '../common/AssignmentUtils'

const AppraisalInfoSection = ({ assignmentDetails }) =>
  <LgySubsection header='Appraisal Information' className='assignment-details-child'>
    <table>
      <caption className='usa-sr-only'>Appraisal Information</caption>
      <tbody>
        <tr>
          <th scope='row'>Expiration date:</th>
          <td>{assignmentDetails.novExpirationDate ? format(assignmentDetails.novExpirationDate, 'MM/dd/yyyy', { awareOfUnicodeTokens: true }) : ''}</td>
        </tr>
        <tr>
          <th scope='row'>Report date:</th>
          <td>{assignmentDetails.appraisalReportDate ? format(assignmentDetails.appraisalReportDate, 'MM/dd/yyyy', { awareOfUnicodeTokens: true }) : ''}</td>
        </tr>
        <tr>
          <th scope='row'>Upload date:</th>
          <td>{assignmentDetails.appraisalReportUploadDate ? format(assignmentDetails.appraisalReportUploadDate, 'MM/dd/yyyy', { awareOfUnicodeTokens: true }) : ''}</td>
        </tr>
        <tr>
          <th scope='row'>Assignment date:</th>
          <td>{format(assignmentDetails.assignmentDate, 'MM/dd/yyyy', { awareOfUnicodeTokens: true })}</td>
        </tr>
        <tr>
          <th scope='row'>Appraiser name and ID:</th>
          <td>{assignmentDetails.appraiserFirstName} {assignmentDetails.appraiserLastName} – {assignmentDetails.appraiserId}</td>
        </tr>
        <tr>
          <th scope='row'>Appraiser address:</th>
          <td>
            {assignmentDetails.appraiserAddressOne}<br />
            {assignmentDetails.appraiserAddressTwo && <span>{assignmentDetails.appraiserAddressTwo}<br /></span>}
            {assignmentDetails.appraiserAddressThree && <span>{assignmentDetails.appraiserAddressThree}<br /></span>}
            {assignmentDetails.appraiserCityName} {assignmentDetails.appraiserStateCode} {assignmentDetails.appraiserZipPrefixNumber}{assignmentDetails.appraiserZipFirstSuffix && `-${assignmentDetails.appraiserZipFirstSuffix}`}
          </td>
        </tr>
        <tr>
          <th scope='row'>Appraiser phone number:</th>
          <td>{formatPhone(assignmentDetails.appraiserWorkPhone)} {assignmentDetails.appraiserPhoneExt && `Ext. ${assignmentDetails.appraiserPhoneExt}`}</td>
        </tr>
        <tr>
          <th scope='row'>Appraiser email:</th>
          <td>{assignmentDetails.appraiserEmail}</td>
        </tr>
      </tbody>
    </table>
  </LgySubsection>

export default AppraisalInfoSection
